<!-- Aviso de incompletude: só quando há execuções pendentes de reconciliação. -->
<po-tag
  *ngIf="pendingRuns > 0"
  class="costs-kpis__tag costs-kpis__tag--pending"
  p-type="warning"
  [p-icon]="true"
  [p-value]="pendingWarning">
</po-tag>

<div class="po-row">
  <po-widget class="po-md-3" p-title="Custo total">
    <p class="po-font-display">{{ costLabel }}<span class="po-icon po-icon-info costs-kpis__help"
      [p-tooltip]="cardHelp.cost" p-tooltip-position="bottom" p-append-in-body="true"></span></p>

    <!-- Variação como po-tag: sobe em vermelho porque custo subindo é o que merece
         atenção; cair é o resultado desejado. -->
    <po-tag
      *ngIf="costChange as change"
      class="costs-kpis__tag"
      [p-type]="change.flat ? 'info' : (change.up ? 'danger' : 'success')"
      [p-value]="change.label + ' vs. período anterior'">
    </po-tag>

    <po-info p-label="Período" [p-value]="periodLabel" p-orientation="horizontal"></po-info>
    <po-info
      *ngIf="costChange"
      p-label="Período anterior"
      [p-value]="previousCostLabel"
      p-orientation="horizontal">
    </po-info>
    <po-info
      *ngIf="monthlyRunRateLabel as runRate"
      p-label="Projeção mensal"
      [p-value]="runRate"
      p-orientation="horizontal">
    </po-info>
    <!-- Piso das execuções de trace truncado. Fora do total de propósito: somar daria
         um número que não é nem o apurado nem o real. -->
    <po-info
      *ngIf="hasPartialCost"
      p-label="Piso não somado"
      [p-value]="partialCostLabel"
      p-orientation="horizontal">
    </po-info>
  </po-widget>

  <po-widget class="po-md-3" p-title="Custo médio por execução">
    <p class="po-font-display">{{ costPerRunLabel }}<span class="po-icon po-icon-info costs-kpis__help"
      [p-tooltip]="cardHelp.averages" p-tooltip-position="bottom" p-append-in-body="true"></span></p>

    <po-tag
      *ngIf="costPerRunChange as change"
      class="costs-kpis__tag"
      [p-type]="change.flat ? 'info' : (change.up ? 'danger' : 'success')"
      [p-value]="change.label + ' vs. período anterior'">
    </po-tag>

    <po-info p-label="Por review" [p-value]="costPerResourceLabel" p-orientation="horizontal"></po-info>
    <po-info p-label="Reviews distintos" [p-value]="distinctReviewsLabel" p-orientation="horizontal"></po-info>
  </po-widget>

  <po-widget class="po-md-3" p-title="Tokens reais">
    <p class="po-font-display">{{ tokensLabel }}<span class="po-icon po-icon-info costs-kpis__help"
      [p-tooltip]="cardHelp.tokens" p-tooltip-position="bottom" p-append-in-body="true"></span></p>
    <po-info
      *ngIf="tokenSplitLabel"
      p-label="Entrada / saída"
      [p-value]="tokenSplitLabel"
      p-orientation="horizontal">
    </po-info>
    <po-info p-label="Total exato" [p-value]="tokensExactLabel" p-orientation="horizontal"></po-info>
    <po-info
      *ngIf="hasCachedTokens"
      p-label="Reaproveitado de cache"
      [p-value]="cachedTokensLabel"
      p-orientation="horizontal">
    </po-info>
    <po-info
      *ngIf="reportedGapLabel"
      p-label="Auto-reporte do provider"
      [p-value]="reportedGapLabel"
      p-orientation="horizontal">
    </po-info>
  </po-widget>

  <po-widget class="po-md-3" p-title="Execuções">
    <p class="po-font-display">{{ runsTotal }}<span class="po-icon po-icon-info costs-kpis__help"
      [p-tooltip]="cardHelp.runs" p-tooltip-position="bottom" p-append-in-body="true"></span></p>
    <po-info p-label="Reconciliadas" [p-value]="reconciledLabel" p-orientation="horizontal"></po-info>
    <po-info
      *ngIf="hasPartialCost"
      p-label="Custo parcial"
      [p-value]="partialRunsLabel"
      p-orientation="horizontal">
    </po-info>
    <po-info
      *ngIf="unaccountableRuns > 0"
      p-label="Sem custo apurável"
      [p-value]="unaccountableLabel"
      p-orientation="horizontal">
    </po-info>
  </po-widget>
</div>
